import { Box, Container, Grid } from "@mui/material";
import React, { useState } from "react";
import GlobalHeader from "./global-header/GlobalHeader";
import NewLoggedinHeader from "./loggedin-header/NewLoggedinHeader";
import HideNewHeaderOnScroll from "../../../hooks/HideNewHeaderOnScroll";

const Header = () => {
  const [loggedin] = useState(true);
  return (
    <>
      <Box className={"header visible"}>
        <HideNewHeaderOnScroll
          handleClosePopover={() => {}}
          headerClass={".header"}
        />
        <Container
          maxWidth="none"
          sx={{ padding: "0 !important", height: "100%" }}
        >
          <Grid container height={"100%"}>
            {loggedin ? <NewLoggedinHeader /> : <GlobalHeader />}
          </Grid>
        </Container>
      </Box>
      <Box className="header-spacer"></Box>
    </>
  );
};
export default Header;
